import type { ArtAsset } from "../art/validate";

const rawModules = import.meta.glob("../art/*.art.json", { eager: true }) as Record<
  string,
  ArtAsset | { default: ArtAsset }
>;

const assetsById = new Map<string, ArtAsset>();

for (const mod of Object.values(rawModules)) {
  const asset = "default" in mod ? mod.default : mod;
  if (asset && typeof asset.id === "string") {
    assetsById.set(asset.id, asset);
  }
}

export function allAssets(): ArtAsset[] {
  return [...assetsById.values()];
}

/**
 * Returns the art asset for `species`, falling back safely to any available asset
 * if the requested species asset has not been added to this worktree yet.
 */
export function assetFor(species: string): ArtAsset {
  const exact = assetsById.get(species);
  if (exact) return exact;
  const shark = assetsById.get("shark");
  if (shark) return shark;
  const dog = assetsById.get("dog");
  if (dog) return dog;
  const first = assetsById.values().next().value;
  if (!first) {
    throw new Error("No art assets found in apps/web/src/art/*.art.json");
  }
  return first;
}
